import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import _ from 'lodash';
import moment from 'moment';
import { CSVDownload } from 'react-csv/lib';

import { get as getStudentAggregateAnalytics } from 'actions/student-analytics';
import TabComponentSemantic from './components/tabs';
import PersonalDetails from './components/personal-details';

import { median } from '../teacher-analytics/utils/data-parser';

import { Header, Statistic, Button, Message } from 'semantic-ui-react';

export class StudentAggregateTable extends PureComponent {
  static propTypes = {
    studentAggregateAnalytics: PropTypes.shape({}),
    actions: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      data: null,
      loading: true,
      processedData: null,
      loadCSV: false,
    };
  }

  static getDerivedStateFromProps(
    { studentAggregateAnalytics, queryObj, loadCSV },
    prevState,
  ) {
    let newState = {};
    const studentAggregateAnalyticsGet = store.get(
      studentAggregateAnalytics,
      'ANALYTICS',
      queryObj,
    );
    if (studentAggregateAnalyticsGet) {
      if (
        studentAggregateAnalyticsGet.data &&
        prevState.data !== studentAggregateAnalyticsGet.data
      ) {
        newState['data'] = studentAggregateAnalyticsGet.data;
        newState['loading'] = false;
        newState['loadCSV'] = loadCSV;
      }
    }
    if (newState === {}) {
      return null;
    }
    return newState;
  }

  componentDidUpdate(prevProps) {
    const { queryObj, actions } = this.props;
    if (!_.isEqual(queryObj, prevProps.queryObj)) {
      actions.getStudentAggregateAnalytics('ANALYTICS', queryObj);
      this.setState({
        loading: true,
      });
    }
  }

  componentDidMount() {
    const { actions, queryObj } = this.props;
    actions.getStudentAggregateAnalytics('ANALYTICS', queryObj);
    this.setState({
      loading: true,
    });
  }

  fetchData = (state, instance) => {
    const { setPageNumberSizeSortedFiltered, queryObj } = this.props;
    if (
      state.page + 1 !== queryObj.page ||
      state.pageSize !== queryObj.page_size ||
      state.sorted.length > 0
    ) {
      setPageNumberSizeSortedFiltered(
        state.page + 1,
        state.pageSize,
        state.sorted[0],
        state.filtered,
        false,
      );
      this.setState({
        loading: true,
      });
    }
  };

  getCSVData = () => {
    const { setPageNumberSizeSortedFiltered } = this.props;
    const { data } = this.state;
    setPageNumberSizeSortedFiltered(1, data.student_prg_count, null, null, true);
  };

  makeDownloadable = studentData => {
    let outData = studentData.map(std => {
      let meanDoubtToCallTimeList = [];
      std.doubt_to_call_time.forEach(dbtCall => {
        if (dbtCall.length > 1) {
          meanDoubtToCallTimeList.push(median(dbtCall));
        } else if (dbtCall.length === 1) {
          meanDoubtToCallTimeList.push(dbtCall[0]);
        }
      });
      let medianDbtToCallTime = median(meanDoubtToCallTimeList) / 60.0;

      let number_of_doubts =
        std.num_doubts.length > 0
          ? (_.sum(std.num_doubts) / std.num_doubts.length).toFixed(1)
          : 'NA';
      let itemsAttemptedCorrectly = std.items_attempted_correctly.filter(tm => tm !== 0);
      let itemAttemptedCorrectly1 = median(itemsAttemptedCorrectly).toFixed(1);
      let classroomtime = (_.sum(std.lesson_time) / 60.0).toFixed(1);
      let homework = (
        (_.sum(std.assessment_time) +
          _.sum(std.homework_time) +
          _.sum(std.remedial_time)) /
        60.0
      ).toFixed(1);
      return {
        name: std.name,
        joinedOn: std.dt_joined,
        ratings: std.avg_rating,
        classes_attended: std.classes_attended,
        classes_total: std.classes_total,
        attendance: std.attendance,
        avg_call_time: std.avg_call_time,
        doubt_to_call_time: medianDbtToCallTime,
        num_doubts: number_of_doubts,
        avg_time_on_worksheets: std.avg_time_on_worksheets,
        Items_class: itemAttemptedCorrectly1,
        baseline: std.baseline,
        OPM: std.avg_performance,
        // homework_assessment_time:std.homework_assessment_time,
        homework_assessment_time: homework,
        // classroom_time :std.classroom_time,
        classroom_time: classroomtime,
        ocm: std.cumulative_completion_metric,
        Pending_assessments: std.pending_assessments,
        pending_homeworks: std.pending_homework,
        pending_remedials: std.pending_remedials,
      };
    });

    return outData;
  };

  render() {
    const { data, loading, loadCSV } = this.state;
    const { queryObj } = this.props;
    if (!data) {
      return <div>No Data</div>;
    }
    const { students, student_count, student_prg_count } = data;
    return (
      <div>
        {student_count && (
          <div>
            <Message info>
              <Message.Header>
                This query returned {student_prg_count} results of whom there are{' '}
                {student_count} unique students who have state {queryObj.state} in this
                time period
              </Message.Header>
            </Message>
            <div>
              {loadCSV === false ? (
                <Button
                  onClick={this.getCSVData}
                  color={'olive'}
                  content={'Download CSV'}
                />
              ) : (
                <CSVDownload data={this.makeDownloadable(students)} target="_blank" />
              )}
            </div>
          </div>
        )}
        {students && loadCSV !== true && (
          <ReactTable
            columns={[
              {
                Header: 'Personal Details',
                headerClassName: 'personal-details',
                columns: [
                  {
                    Header: 'Name',
                    id: 'name',
                    sortable: true,
                    sortMethod: (a, b) => (a.name > b.name ? 1 : -1),
                    accessor: d => <PersonalDetails data={d} />,
                    maxWidth: 250,
                  },
                  {
                    Header: 'Joined On',
                    sortable: true,
                    id: 'dt_joined',
                    accessor: d => {
                      var a = moment(d.dt_joined, 'YYYY-MM-DD');
                      var b = moment(new Date().toString());
                      var months = b.diff(a, 'months');
                      return (
                        <Header as="h4">
                          {d.dt_joined}
                          <br />({months} months ago)
                        </Header>
                      );
                    },
                    maxWidth: 120,
                  },
                  {
                    Header: 'Ratings',
                    id: 'avg_rating',
                    sortable: true,
                    accessor: d => (
                      <Statistic text size="mini">
                        <Statistic.Value>
                          {d.avg_rating === -1 ? 'NA' : d.avg_rating.toFixed(1)}
                        </Statistic.Value>
                        <Statistic.Label>{d.rating.length} ratings</Statistic.Label>
                      </Statistic>
                    ),
                    maxWidth: 80,
                  },
                ],
              },
              {
                Header: 'Classroom Interactions',
                headerClassName: 'classroom-interactions',
                columns: [
                  {
                    Header: '# Classes Attended/Scheduled',
                    id: 'classes_attended',
                    sortable: true,
                    maxWidth: 70,
                    accessor: d => (
                      <Statistic
                        size="mini"
                        color={
                          d.classes_attended < 6 * d.months_since_joined
                            ? 'red'
                            : d.classes_attended < 8 * d.months_since_joined
                            ? 'yellow'
                            : 'green'
                        }
                      >
                        <Statistic.Value>
                          {d.classes_attended}/{d.classes_total}
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'Attendance',
                    id: 'attendance',
                    sortable: true,
                    maxWidth: 100,
                    accessor: d => {
                      let attendance = d.attendance * 100;
                      return (
                        <Statistic
                          size="tiny"
                          color={
                            attendance < 80 ? 'red' : attendance < 90 ? 'yellow' : 'green'
                          }
                        >
                          <Statistic.Value>{attendance.toFixed(1)}%</Statistic.Value>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: 'Call Time (avg)',
                    id: 'avg_call_time',
                    sortable: true,
                    maxWidth: 70,
                    accessor: d => {
                      let callsMadeTime = d.total_call_time.filter(tm => tm !== 0);
                      return (
                        <Statistic
                          size="mini"
                          color={median(callsMadeTime) < 5 ? 'red' : 'black'}
                        >
                          <Statistic.Value>
                            {median(callsMadeTime).toFixed(1)}
                          </Statistic.Value>
                          <Statistic.Label>mins</Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: 'Doubt to Call Time',
                    id: 'doubt_to_call_time',
                    sortable: false,
                    maxWidth: 70,
                    accessor: d => {
                      let meanDoubtToCallTimeList = [];
                      d.doubt_to_call_time.forEach(dbtCall => {
                        if (dbtCall.length > 1) {
                          meanDoubtToCallTimeList.push(median(dbtCall));
                        } else if (dbtCall.length === 1) {
                          meanDoubtToCallTimeList.push(dbtCall[0]);
                        }
                      });
                      let medianDbtToCallTime = median(meanDoubtToCallTimeList) / 60.0;
                      return (
                        <Statistic
                          size="mini"
                          color={medianDbtToCallTime > 8 ? 'red' : 'black'}
                        >
                          <Statistic.Value>
                            {medianDbtToCallTime.toFixed(1)}
                          </Statistic.Value>
                          <Statistic.Label>mins</Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: '#Doubts',
                    id: 'sum_doubts',
                    sortable: false,
                    maxWidth: 110,
                    accessor: d => {
                      return (
                        <Statistic size="mini">
                          <Statistic.Value>{_.sum(d.num_doubts)}</Statistic.Value>
                          <Statistic.Label>
                            @{' '}
                            {d.num_doubts.length > 0
                              ? (_.sum(d.num_doubts) / d.num_doubts.length).toFixed(1)
                              : 'NA'}{' '}
                            doubt <br />
                            per class
                          </Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: 'Time on Worksheets',
                    id: 'avg_time_on_worksheets',
                    sortable: true,
                    maxWidth: 70,
                    accessor: d => {
                      return (
                        <Statistic
                          size="mini"
                          color={d.avg_time_on_worksheets < 35 ? 'red' : 'black'}
                        >
                          <Statistic.Value>
                            {d.avg_time_on_worksheets.toFixed(1)}
                          </Statistic.Value>
                          <Statistic.Label>mins</Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                  {
                    Header: '#Items/Class',
                    id: 'avg_items_attempted_correctly',
                    sortable: true,
                    maxWidth: 70,
                    accessor: d => {
                      let itemsAttemptedCorrectly = d.items_attempted_correctly.filter(
                        tm => tm !== 0,
                      );
                      return (
                        <Statistic
                          size="mini"
                          color={median(itemsAttemptedCorrectly) < 17 ? 'red' : 'black'}
                        >
                          <Statistic.Value>
                            {median(itemsAttemptedCorrectly).toFixed(1)}
                          </Statistic.Value>
                          <Statistic.Label>/class</Statistic.Label>
                        </Statistic>
                      );
                    },
                  },
                ],
              },
              {
                Header: 'Performance Metrics',
                headerClassName: 'performance',
                columns: [
                  {
                    Header: 'Baseline',
                    id: 'baseline',
                    sortable: true,
                    filterable: false,
                    maxWidth: 90,
                    accessor: d => (
                      <Statistic size="tiny" color={'black'}>
                        <Statistic.Value>
                          {d.baseline === 'NA'
                            ? 'NA'
                            : (d.baseline * 100).toFixed(1) + '%'}
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'OPM',
                    id: 'avg_performance',
                    sortable: true,
                    filterable: false,
                    maxWidth: 90,
                    accessor: d => (
                      <Statistic size="tiny" color={d.performance_category}>
                        <Statistic.Value>
                          {(d.avg_performance * 100).toFixed(1)}%
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'HW + Assessment + remedial sheets: Time Spent',
                    id: 'homework_assessment_time',
                    sortable: false,
                    filterable: false,
                    maxWidth: 70,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>
                          {(
                            (_.sum(d.assessment_time) +
                              _.sum(d.homework_time) +
                              _.sum(d.remedial_time)) /
                            60.0
                          ).toFixed(1)}
                        </Statistic.Value>
                        <Statistic.Label>hrs</Statistic.Label>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'Lesson Sheets: Time Spent',
                    id: 'classroom_time',
                    sortable: false,
                    filterable: false,
                    maxWidth: 70,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>
                          {(_.sum(d.lesson_time) / 60.0).toFixed(1)}
                        </Statistic.Value>
                        <Statistic.Label>hrs</Statistic.Label>
                      </Statistic>
                    ),
                  },
                ],
              },
              {
                Header: 'Completion Metrics',
                headerClassName: 'completion',
                columns: [
                  {
                    Header: 'OCM',
                    id: 'cumulative_completion_metric',
                    sortable: true,
                    filterable: false,
                    maxWidth: 130,
                    accessor: d => (
                      <Statistic size="tiny" color={d.completion_category}>
                        <Statistic.Value>
                          {(d.cumulative_completion_metric * 100).toFixed(1)}%
                        </Statistic.Value>
                        <Statistic.Label>
                          of {d.total_sheets_prg} sheets
                          <br /> in {d.months_since_joined} months
                        </Statistic.Label>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'Assessments: Pending/Assigned',
                    id: 'pending_assessments',
                    sortable: true,
                    filterable: false,
                    maxWidth: 70,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>
                          {d.pending_assessments}/
                          {d.assessment_time.length + d.pending_assessments}
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'Homework: Pending/Assigned',
                    id: 'pending_homeworks',
                    sortable: true,
                    filterable: false,
                    maxWidth: 70,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>
                          {d.pending_homework}/
                          {d.homework_time.length + d.pending_homework}
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                  {
                    Header: 'Remedials: Pending/Assigned',
                    id: 'pending_remedials',
                    sortable: true,
                    filterable: false,
                    maxWidth: 70,
                    accessor: d => (
                      <Statistic size="mini">
                        <Statistic.Value>
                          {d.pending_remedials}/
                          {d.remedial_time.length + d.pending_remedials}
                        </Statistic.Value>
                      </Statistic>
                    ),
                  },
                ],
              },
            ]}
            SubComponent={row => {
              return <TabComponentSemantic data={row.original} />;
            }}
            manual // Forces table not to paginate or sort automatically, so we can handle it server-side
            onFetchData={this.fetchData}
            data={students}
            loading={loading} // Display the loading overlay when we need it
            pages={Math.ceil(student_prg_count / queryObj.page_size)}
            pageSize={queryObj.page_size}
            defaultPageSize={20}
            page={queryObj.page - 1}
            showPagination={true}
            className="-striped -highlight"
            multiSort={false}
          />
        )}
      </div>
    );
  }
}

export default connect(
  ({ studentAggregateAnalytics }) => ({
    studentAggregateAnalytics: studentAggregateAnalytics,
  }),
  dispatch => ({
    actions: bindActionCreators({ getStudentAggregateAnalytics }, dispatch),
  }),
)(StudentAggregateTable);
